import { render, staticRenderFns } from "./ChangeClassEdit.vue?vue&type=template&id=325a54bd"
import script from "./ChangeClassEdit.vue?vue&type=script&lang=js"
export * from "./ChangeClassEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports